import styled from 'styled-components';
import { ReactComponent as StickyNoteSvg } from '../icons/sticky_note_2.svg';

export const NotesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 0 10px;
  margin-bottom: 8px;
  font-family: 'Poppins', sans-serif;
  border-bottom: 1px solid #eef0f3;
  cursor: pointer;
`;

export const NotesIcon = styled(StickyNoteSvg)`
  color: #3478d7 !important;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const NotesTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const NotesHint = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #8a8a8a;
`;

export const ContactNotesStyled = styled.div`
  * {
    font-family: Montserrat;
  }
  width: 100%;
  position: relative;

  .tooltip {
    display: none;
  }

  &:hover {
    div:nth-child(3) {
      * {
        color: rgb(182 186 188) !important;
        background-color: #fff !important;
      }
    }

    .tooltip {
      position: absolute;
      display: inline-flex;
      background-color: rgba(97, 97, 97, 0.92);
      color: #fff;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 500;
      vertical-align: middle;
      top: 55%;
      left: 50%;
      margin-top: auto;
      margin-bottom: auto;
      transform: translate(-50%);
    }
  }

  h3 {
    color: #6c7075;
    font-size: 14px;
    cursor: pointer;

    span {
      font-weight: 400;
    }
  }

  div:nth-child(3) {
    padding: 16px;
    font-size: 14px;
    border: 1px solid #d4d7d9;
    border-radius: 4px;
    cursor: pointer;
    color: #555555;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 120px;

    & p {
      margin-bottom: auto;
    }
  }
`;

export const ContactNotesViewStyled = styled.div`
  @media screen and (min-width: 425px) {
    padding: 24px;
    padding-top: 16px;
  }
`;
